import { CloneStoryMeta, CloneStoryPayload } from 'types/store/CloneStory';
import { createAsyncAction } from 'utils/Redux';

const ns = 'CLONE_STORY_NS';

const asyncAction = createAsyncAction<CloneStoryMeta, CloneStoryPayload>(ns);

const cloneStoryActions = { ...asyncAction };

export default cloneStoryActions;
